import { render, staticRenderFns } from "./emptyLayout.vue?vue&type=template&id=38d41c0e&scoped=true&"
import script from "./emptyLayout.vue?vue&type=script&lang=js&"
export * from "./emptyLayout.vue?vue&type=script&lang=js&"
import style0 from "./emptyLayout.vue?vue&type=style&index=0&id=38d41c0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d41c0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VContainer,VFlex,VFooter,VLayout,VMain,VTab,VTabs})
